import React, { useEffect } from "react";
import Select from "../Select/Select";
import TextInput from "../TextInput/TextInput";
import RadioButtonGroup from "../RadioButtonGroup/RadioButtonGroup";
import FileUpload from "../FileUpload/FileUpload";
import MultiFileUpload from "../MultiFileUpload/MultiFileUpload";
import MultiSelectWrapper from "../MultiSelect/MultiSelect";
import DatePicker from "../DatePicker/DatePicker";
import TextareaInput from "../TextareaInput/TextareaInput";
import HierarchySelect from "../HierarchySelect/HierarchySelect";
import Checkbox from "../Checkbox/Checkbox";
import FileUploadForMR from "../FileUploadForMasterResource/FileUploadForMR";
import SearchDropdown from "../SearchDropdown/SearchDropdown";
import TimePicker from "../TimePicker/TimePicker";
import InputWithDynamicFields from "../TextInputForDynamicFields/TextInputDynamic";
import CheckboxGroup from "../Checkbox/MultiCheckBox";
import CheckboxGroupWeb from "../Checkbox/MultiCheckboxForMobile";
import CheckboxGroupMulti from "../Checkbox/MultiCheckBoxForCheck";
import ModulePermissionsGrid from "../../../RoleManagement/CreateRole/ModulePermissionsGrid ";
import TextInputUserName from "../TextInput/TextInputUserName";

const FormHandler = ({
  register,
  errors,
  setValue,
  setValueForInput,
  getValues,
  fields,
  columns,
  control = {},
  setvendorName,
  onChange,
  checkboxOnChange,
  onChangeForRegion,
  openMapHandler,
  is_multi,
  isMultiSelectDisabled,
  imgName,
  isTextFieldDisable,
  roleName,
  isTextFieldDisableforrole,
  addresses,
  Description,
  isContactFieldDisable,
  webaccess,
  mobileAccess,
  isBankFieldDisable,
  isBranchNameFieldDisable,
  edit = false,
  makeRadioButtonForBranchUserDisable,
  roleTrue,
  userNameDisable,
  isCurrentUserAdmin,
  userLevelDisabled,
}) => {
  const isFieldMandatory = (field) => {
    if (typeof field.mandatory === "function") {
      const formValues = getValues ? getValues() : {};
      return field.mandatory(formValues);
    }
    return field.mandatory === "true";
  };

  const generateField = (field) => {
    let component;
    const {
      name,
      label,
      options,
      type,
      mandatory,
      id,
      heading,
      // label1,
      // label2,
      maxLength,
      disabled,
      is_multi,
      editId,
      defaultselect,
      disableField,
      style,
      parentLabel,
    } = field;

    // Determine if the field is mandatory based on the dynamic logic
    const isMandatory = isFieldMandatory(field);
    const isDisabled =
      typeof field.disabled === "function"
        ? field.disabled({ roleName })
        : field.disabled ||
          isTextFieldDisable ||
          disableField ||
          isContactFieldDisable;

    switch (type) {
      case "input":
        component = (
          <TextInput
            name={name}
            label={label}
            maxLength={maxLength}
            register={register}
            errors={errors}
            mandatory={
              field.name === "Latitude" || field.name === "longitude"
                ? isMandatory
                : mandatory
            }
            disabled={isDisabled || Description || edit}
            openMapHandler={openMapHandler}
            isTextFieldDisable={isTextFieldDisable}
            Description={Description}
            style={style}
            isContactFieldDisable={isContactFieldDisable}
          />
        );
        break;
      case "input_username":
        component = (
          <TextInputUserName
            name={name}
            label={label}
            maxLength={maxLength}
            register={register}
            errors={errors}
            mandatory={
              field.name === "Latitude" || field.name === "longitude"
                ? isMandatory
                : mandatory
            }
            disabled={isDisabled || Description || edit || userNameDisable}
            openMapHandler={openMapHandler}
            isTextFieldDisable={isTextFieldDisable}
            Description={Description}
            style={style}
            isContactFieldDisable={isContactFieldDisable}
          />
        );
        break;
      case "dynamic_input":
        component = (
          <InputWithDynamicFields
            name={name}
            label={label}
            register={register}
            errors={errors}
            mandatory={mandatory}
            maxFields={field.maxFields}
            maxLength={maxLength}
            setValue={setValueForInput}
            disabled={isDisabled}
            style={style}
            addresses={addresses}
          />
        );
        break;
      case "checkboxmulti":
        component = (
          <CheckboxGroup
            key={`checkbox-group-${webaccess}`}
            options={field.options}
            name={name}
            label={label}
            control={control}
            mandatory={mandatory}
            id={id}
            heading={heading}
            parentLabel={parentLabel}
            disabled={!webaccess || disableField}
            webaccess={!webaccess}
          />
        );
        break;
      case "checkboxmultiGroup":
        component = (
          <CheckboxGroupMulti
            options={field.options}
            name={name}
            label={label}
            control={control}
            mandatory={mandatory}
            id={id}
            heading={heading}
            parentLabel={parentLabel}
            // disabled={hasWebAccess || disableField}
            // hasWebAccess={hasWebAccess}
          />
        );
        break;
      case "checkboxmultiGroupWeb":
        component = (
          <CheckboxGroupWeb
            options={field.options}
            name={name}
            label={label}
            control={control}
            mandatory={mandatory}
            id={id}
            heading={heading}
            parentLabel={parentLabel}
            disabled={!mobileAccess || disableField}
            mobileAccess={!mobileAccess}
          />
        );
        break;
      case "radio":
        component = (
          <RadioButtonGroup
            options={options}
            name={name}
            control={control}
            errors={errors}
            parentLabel={parentLabel || label}
            mandatory={mandatory}
            disabled={
              webaccess ||
              disableField ||
              isBankFieldDisable ||
              makeRadioButtonForBranchUserDisable
            }
            webaccess={webaccess}
            isBankFieldDisable={isBankFieldDisable}
            edit={edit}
            makeRadioButtonForBranchUserDisable={
              makeRadioButtonForBranchUserDisable
            }
            isCurrentUserAdmin={isCurrentUserAdmin}
          />
        );
        break;
      case "select":
        const isUserLevelDisabled =
          name === "userLevel"
            ? userLevelDisabled ||
              isTextFieldDisable ||
              disableField ||
              isContactFieldDisable
            : false;
        const isOtherSelectDisabled =
          isTextFieldDisable ||
          disableField ||
          isContactFieldDisable ||
          roleTrue;

        const selectComponent = (
          <Select
            name={name}
            label={label}
            register={register}
            errors={errors}
            options={options}
            mandatory={mandatory}
            defaultselect={defaultselect}
            disabled={
              name === "userLevel" ? isUserLevelDisabled : isOtherSelectDisabled
            }
            isTextFieldDisable={isTextFieldDisable}
            style={style}
            isContactFieldDisable={isContactFieldDisable}
          />
        );

        // Add tooltip wrapper only for userLevel field when disabled
        if (name === "userLevel" && isUserLevelDisabled) {
          component = (
            <div
              style={{ display: "inline-block", width: "100%" }}
              title="User Level cannot be modified while the user is involved in active tickets."
              data-bs-toggle="tooltip"
              data-bs-placement="top"
            >
              {selectComponent}
            </div>
          );
        } else {
          component = selectComponent;
        }
        break;

      case "bankbranchselect":
        component = (
          <Select
            name={name}
            label={label}
            register={register}
            errors={errors}
            options={options}
            mandatory={mandatory}
            defaultselect={defaultselect}
            disabled={
              isTextFieldDisable ||
              disableField ||
              isContactFieldDisable ||
              isBankFieldDisable
            }
            isTextFieldDisable={isTextFieldDisable}
            style={style}
            isContactFieldDisable={isContactFieldDisable}
            isBankFieldDisable={isBankFieldDisable}
          />
        );
        break;
      case "branchnameselect":
        component = (
          <Select
            name={name}
            label={label}
            register={register}
            errors={errors}
            options={options}
            mandatory={mandatory}
            defaultselect={defaultselect}
            disabled={
              isTextFieldDisable ||
              disableField ||
              isContactFieldDisable ||
              isBranchNameFieldDisable ||
              isBankFieldDisable
            }
            isTextFieldDisable={isTextFieldDisable}
            style={style}
            isContactFieldDisable={isContactFieldDisable}
            isBranchNameFieldDisable={isBranchNameFieldDisable}
          />
        );
        break;
      case "single_select":
        component = (
          <SearchDropdown
            name={name}
            label={label}
            register={register}
            errors={errors}
            options={options}
            onChange={onChange}
            control={control}
            mandatory={mandatory}
            style={style}
          />
        );
        break;

      case "hier_select":
        component = (
          <HierarchySelect
            name={name}
            label={label}
            register={register}
            errors={errors}
            options={options}
            onChange={onChange}
            control={control}
            mandatory={mandatory}
            disabled={disabled || isContactFieldDisable}
            isTextFieldDisableforrole={isTextFieldDisableforrole}
            isContactFieldDisable={isContactFieldDisable}
          />
        );
        break;
      case "module_permissions_grid":
        component = (
          <div>
            <ModulePermissionsGrid
              name={name}
              label={label}
              control={control}
              selectedModules={field.selectedModules}
              helpText={field.helpText}
              setValue={setValue}
              getValues={getValues}
              edit={edit}
              gisModuleIds={field.gisModuleIds || []}
            />
          </div>
        );
        break;

      case "multi_select":
        component = (
          <MultiSelectWrapper
            name={name}
            label={label}
            register={register}
            errors={errors}
            is_multi={is_multi}
            options={options}
            mandatory={mandatory}
            control={control}
            isMultiSelectDisabled={isMultiSelectDisabled}
            disabled={disabled || isTextFieldDisable}
            onChangeForRegion={onChangeForRegion}
            isTextFieldDisable={isTextFieldDisable}
          />
        );
        break;
      case "file_upload":
        component = (
          <FileUpload
            label={label}
            register={register}
            name={name}
            errors={errors}
            mandatory={mandatory}
            control={control}
            id={id}
            setValue={setValue}
            getValues={getValues}
            editId={editId}
          />
        );
        break;
      case "file_upload_MR":
        component = (
          <FileUploadForMR
            label={label}
            register={register}
            name={name}
            errors={errors}
            mandatory={mandatory}
            control={control}
            id={id}
            setValue={setValue}
            getValues={getValues}
            editId={editId}
            imgName={imgName}
          />
        );
        break;
      case "multi_file_upload":
        component = (
          <MultiFileUpload
            label={label}
            register={register}
            name={name}
            errors={errors}
            mandatory={mandatory}
            control={control}
            id={id}
            setValue={setValue}
            getValues={getValues}
            editId={editId}
          />
        );
        break;
      case "text_area":
        component = (
          <TextareaInput
            label={label}
            register={register}
            name={name}
            errors={errors}
            mandatory={mandatory}
            control={control}
            id={id}
            disabled={
              isTextFieldDisable || Description || isContactFieldDisable
            }
            isTextFieldDisable={isTextFieldDisable}
            Description={Description}
            isContactFieldDisable={isContactFieldDisable}
            maxLength={maxLength}
          />
        );
        break;
      case "checkbox":
        component = (
          <Checkbox
            label={label}
            onChange={checkboxOnChange}
            name={name}
            mandatory={mandatory}
            control={control}
            id={id}
            heading={heading}
          />
        );
        break;
      // case "checkboxmulti":
      //   component = (
      //     <CheckboxGroup
      //       options={field.options}  // Pass multiple checkboxes
      //       name={name}
      //       label={label}
      //       control={control}
      //       mandatory={mandatory}
      //       id={id}
      //       heading={heading}
      //       parentLabel={parentLabel}
      //     />
      //   );
      //   break;
      // case "map":
      //   component = (
      //     <MapWrapper
      //       label2={label2}
      //       // register={register}
      //       name={name}
      //       errors={errors}
      //       mandatory={mandatory}
      //       control={control}
      //       id={id}
      //       heading={heading}
      //     />
      //   );
      //   break;

      case "date":
        component = (
          <DatePicker
            label={label}
            register={register}
            name={name}
            errors={errors}
            mandatory={field.name === "paymentDate" ? isMandatory : mandatory}
            disabled={disabled || isTextFieldDisable || disableField}
          />
        );
        break;
      case "time":
        component = (
          <TimePicker
            name={name}
            label={label}
            register={register}
            errors={errors}
            mandatory={mandatory}
            defaultTimeValue={field.defaultTimeValue}
            disabled={isTextFieldDisable || disableField}
            setTimePicked={setValue}
            style={style}
          />
        );
        break;
      default:
        break;
    }
    return component;
  };

  useEffect(() => {
    if (getValues && setValue) {
      const handleFieldUpdates = () => {
        const values = getValues();
        fields.forEach((field) => {
          if (typeof field.mandatory === "function") {
            if (field.name === "paymentDate" && values.paymentStatus !== "0") {
              setValue("paymentDate", "");
            }
          }
        });
      };
      handleFieldUpdates();
    }
  }, [fields, getValues, setValue]);

  // Check if we have the special layout fields
  const hasModulePermissionsGrid = fields.some(
    (f) => f.type === "module_permissions_grid"
  );
  const webPermIndex = fields.findIndex((f) => f.name === "web_permission");
  const modulePermIndex = fields.findIndex(
    (f) => f.type === "module_permissions_grid"
  );
  const descriptionIndex = fields.findIndex((f) => f.name === "description");

  // If we have the module permissions grid, use special layout
  if (
    hasModulePermissionsGrid &&
    webPermIndex !== -1 &&
    modulePermIndex !== -1 &&
    descriptionIndex !== -1
  ) {
    // Separate fields into groups
    const fieldsBeforeWebPerm = fields.slice(0, webPermIndex);
    const webPermField = fields[webPermIndex];
    const modulePermField = fields[modulePermIndex];
    const descriptionField = fields[descriptionIndex];
    // const otherFields = fields.filter((f, i) =>
    //   i !== webPermIndex && i !== modulePermIndex && i !== descriptionIndex && i < webPermIndex
    // );

    return (
      <div>
        {/* Regular grid for fields before web permission */}
        {fieldsBeforeWebPerm.length > 0 && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: `repeat(${columns}, 1fr)`,
              gap: "0.9rem",
              marginBottom: "0.9rem",
            }}
          >
            {fieldsBeforeWebPerm.map((field) => (
              <div
                key={field.name}
                style={{
                  paddingLeft: "1.2rem",
                  paddingRight: "1.2rem",
                }}
              >
                {generateField(field)}
              </div>
            ))}
          </div>
        )}

        {/* Two column layout with independent flows */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gap: "0.9rem",
            alignItems: "start",
          }}
        >
          {/* Left Column - Web Permission and Description */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.9rem",
              paddingLeft: "1.2rem",
              paddingRight: "1.2rem",
            }}
          >
            {generateField(webPermField)}
            {generateField(descriptionField)}
          </div>

          {/* Right Column - Module Permissions Grid */}
          <div
            style={{
              paddingLeft: "1.2rem",
              paddingRight: "1.2rem",
            }}
          >
            {generateField(modulePermField)}
          </div>
        </div>
      </div>
    );
  }

  // Default grid layout for other forms
  const styles = {
    columnCount: columns,
    columnGap: "30%",
    display: "grid",
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gap: "0.9rem",
  };

  return (
    <div
      style={{
        ...styles,
        ...(fields.some((field) => field.type === "dynamic_input") && {
          gridTemplateColumns: "1fr",
        }),
      }}
    >
      {fields?.map((field) => {
        const shouldSpanFullWidth = field.type === "dynamic_input";

        return (
          <div
            key={field.name}
            style={{
              paddingLeft: "1.2rem",
              paddingRight: "1.2rem",
              ...(shouldSpanFullWidth && { gridColumn: `span ${columns}` }),
            }}
          >
            {generateField(field)}
          </div>
        );
      })}
    </div>
  );
};

export default FormHandler;
